import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const AsyncHome = () => import("../views/Home.vue");
const Valentine = () => import("../views/ValentinePage.vue");

const routes = [
  {
    path: "/",
    name: "valentine",
    component: Valentine,
  },
  {
    path: "/support",
    name: "Support",
    component: AsyncHome,
    children: [
      {
        path: "/",
        component: () => import("../components/MainPageComponents.vue"),
      },
    ],
  },
  {
    path: "/prywatnosc",
    component: () => import("../components/Privacy.vue"),
  },
  {
    path: "/thankyou_single",
    name: "Podziekowanie za pojedyńcze wsparcie",
    component: () => import("../views/ThanksSingle.vue"),
  },
  {
    path: "/thankyou_regular",
    name: "Podziekowanie za regularne wsparcie",
    component: () => import("../views/ThanksRegular.vue"),
  },
  {
    path: "/error",
    name: "Error",
    component: () => import("../views/Error.vue"),
  },
  {
    path: "/pending",
    name: "Pending",
    component: () => import("../views/Pending.vue"),
  },

  {
    path: "/404",
    component: () => import("../views/PageNotFound.vue"),
  },
  {
    path: "*",
    component: () => import("../views/PageNotFound.vue"),
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

export default router;
